import { environment } from 'src/environments/environment';
const ENDPOINTS = {
  SELLER_SERVICE: {
    SEND_OTP: `${environment.API.SELLER_SERVICE.END_POINT.V1.SEND_OTP}`,
    VERIFY_OTP: `${environment.API.SELLER_SERVICE.END_POINT.V1.VERIFY_OTP}`,
    SELLER_INFO: `${environment.API.SELLER_SERVICE.END_POINT.V1.GET_THE_SELLER_INFO}`,
    REGISTER_SELLER : `${environment.API.SELLER_SERVICE.END_POINT.V1.REGISTER_SELLER}`,
    STATES : `${environment.API.SELLER_SERVICE.END_POINT.V1.GET_STATES}`,
    COUNTRIES : `${environment.API.SELLER_SERVICE.END_POINT.V1.GET_COUNTRIES}`,
    CHECK_PINCODE_SERVICE_AVAILABILITY : `${environment.API.SELLER_SERVICE.END_POINT.V1.CHECK_PINCODE_SERVICE_AVAILABILITY}`,
    SIMPLEFIELDS_SELLER_ONBOARDING : `${environment.API.SELLER_SERVICE.END_POINT.V1.SIMPLEFIELDS_SELLER_ONBOARDING}`,
    CHECK_USER_VALIDITY : `${environment.API.SELLER_SERVICE.END_POINT.V1.CHECK_USER_VALIDITY}`,
    SELLER_MAPPING_TO_USER : `${environment.API.SELLER_SERVICE.END_POINT.V1.SELLER_MAPPING_TO_USER}`,
    CREDIT_QUESTIONS: `${environment.API.SELLER_SERVICE.END_POINT.V1.CREDIT_QUESTIONS}`,
    CREDIT_SURVEY: `${environment.API.SELLER_SERVICE.END_POINT.V1.CREDIT_SURVEY}`
  },
  CAMPAIGN_SERVICE: {
    GET_CAMPAIGN_DATA: `${environment.API.CAMPAIGN_SERVICE.END_POINT.V1.GET_CAMPAIGN_DATA}`,
    UPDATE_TRANSACTION_STATUS: `${environment.API.CAMPAIGN_SERVICE.END_POINT.V1.UPDATE_TRANSACTION_STATUS}`,  
  },
  DA_SERVICE: {
    GET_PARTNER_SAMHITHA_ID: `${environment.API.DA_SERVICE.END_POINT.V1.GET_PARTNER_SAMHITHA_ID}`
  },
  AUS_SERVICE: {
    ONBOARD_SELLER: `${environment.API.AUS_SERVICE.END_POINT.V1.ONBOARD_SELLER}`
  }
};

const SECRET_KEY = environment.SECRET_KEY;
const SECRET_IV = environment.SECRET_IV;

export { ENDPOINTS, SECRET_KEY, SECRET_IV };
